import React from 'react'
import { components, useTranslation } from 'cng-web-lib'
import { Grid } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'
import Namespace from 'src/constants/locale/Namespace'
import UaeMpciKeys from 'src/constants/locale/key/UaeMpci'
import makeValidationSchema from './ContainerDetailsMakeValidationSchema'

const {
  form: {
    field: {
      CngTextField,
      CngCodeMasterAutocompleteField
    },
  },
  CngGridItem,
} = components

const DEFAULT_INITIAL_VALUES = Object.freeze({
  id: null,
  billNo: "",
  parentBillNo: "",
  containerNumber: "",
  containerSize: "",
  containerLoadStatus: "",
  sealIdentifier: "",
  containerStatusDescription: "",
  containerVgm: "",
  containerVgmUnit: "",
  temperatureType: "",
  containerTemperature: "",
  temperatureMeasurementCode: "",
  serviceRequirementCode: "",
  cargoType: "",
  sealingPartyCode: "",
  sealingPartyName: "",
  sealType: ""
})

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES },
  makeValidationSchema: makeValidationSchema
}

function Fields({ disabled }) {
  const { setValue, watch } = useFormContext()
  const containerVgm = watch('containerVgm')
  const containerTemperature = watch('containerTemperature')
  const { translate } = useTranslation(Namespace.UAE_MPCI)
  const t = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let containerNumber = translate(Namespace.UAE_MPCI, UaeMpciKeys.ContainerDetails.CONTAINER_NUMBER)
    let containerSize = translate(Namespace.UAE_MPCI, UaeMpciKeys.ContainerDetails.CONTAINER_SIZE)
    let containerLoadStatus = translate(Namespace.UAE_MPCI, UaeMpciKeys.ContainerDetails.CONTAINER_LOAD_STATUS)
    let sealIdentifier = translate(Namespace.UAE_MPCI, UaeMpciKeys.ContainerDetails.SEAL_IDENTIFIER)
    let containerStatusDescription = translate(Namespace.UAE_MPCI, UaeMpciKeys.ContainerDetails.CONTAINER_STATUS_DESCRIPTION)
    let containerVgm = translate(Namespace.UAE_MPCI, UaeMpciKeys.ContainerDetails.CONTAINER_VGM)
    let containerVgmUnit = translate(Namespace.UAE_MPCI, UaeMpciKeys.ContainerDetails.CONTAINER_VGM_UNIT)
    let temperatureType = translate(Namespace.UAE_MPCI, UaeMpciKeys.ContainerDetails.TEMPERATURE_TYPE)
    let containerTemperature = translate(Namespace.UAE_MPCI, UaeMpciKeys.ContainerDetails.CONTAINER_TEMPERATURE)
    let temperatureMeasurementCode = translate(Namespace.UAE_MPCI, UaeMpciKeys.ContainerDetails.TEMPERATURE_MEASUREMENT_CODE)
    let serviceRequirementCode = translate(Namespace.UAE_MPCI, UaeMpciKeys.ContainerDetails.SERVICE_REQUIREMENT_CODE)
    let cargoType = translate(Namespace.UAE_MPCI, UaeMpciKeys.ContainerDetails.CARGO_TYPE)
    let sealingPartyCode = translate(Namespace.UAE_MPCI, UaeMpciKeys.ContainerDetails.SEALING_PARTY_CODE)
    let sealingPartyName = translate(Namespace.UAE_MPCI, UaeMpciKeys.ContainerDetails.SEALING_PARTY_NAME)
    let sealType = translate(Namespace.UAE_MPCI, UaeMpciKeys.ContainerDetails.SEAL_TYPE)

    return {
      containerNumber, containerSize, containerLoadStatus, sealIdentifier,
      containerStatusDescription, containerVgm, containerVgmUnit,
      temperatureType, containerTemperature, temperatureMeasurementCode,
      serviceRequirementCode, cargoType, sealingPartyCode, sealingPartyName, sealType
    }
  }

  return (
    <Grid container spacing={1}>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          required
          name="containerNumber"
          label={t.containerNumber}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 17 }}
          onChange={(e) => setValue("containerNumber", e.target.value.toUpperCase(), { shouldValidate: true })}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngCodeMasterAutocompleteField
          required
          name="containerSize"
          label={t.containerSize}
          disabled={disabled}
          codeType='UAE_MPCI_CONTAINER_SIZE'
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngCodeMasterAutocompleteField
          required
          name="containerLoadStatus"
          label={t.containerLoadStatus}
          disabled={disabled}
          codeType='UAE_MPCI_CONTAINER_LOAD_STATUS'
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          required
          name="sealIdentifier"
          label={t.sealIdentifier}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 35 }}
          onChange={(e) => setValue("sealIdentifier", e.target.value.toUpperCase(), { shouldValidate: true })}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          name="containerStatusDescription"
          label={t.containerStatusDescription}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 35 }}
          onChange={(e) => setValue("containerStatusDescription", e.target.value.toUpperCase(), { shouldValidate: true })}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          name="containerVgm"
          label={t.containerVgm}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 18 }}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngCodeMasterAutocompleteField
          required={!!containerVgm}
          name="containerVgmUnit"
          label={t.containerVgmUnit}
          disabled={disabled}
          codeType='UAE_MPCI_VGM_UNIT'
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngCodeMasterAutocompleteField
          name="temperatureType"
          label={t.temperatureType}
          disabled={disabled}
          codeType='UAE_MPCI_TEMPERATURE_TYPE'
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          name="containerTemperature"
          label={t.containerTemperature}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 15 }}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngCodeMasterAutocompleteField
          required={!!containerTemperature}
          name="temperatureMeasurementCode"
          label={t.temperatureMeasurementCode}
          disabled={disabled}
          codeType='UAE_MPCI_TEMP_MEASUREMENT'
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngCodeMasterAutocompleteField
          name="serviceRequirementCode"
          label={t.serviceRequirementCode}
          disabled={disabled}
          codeType='UAE_MPCI_SERVICE_REQUIREMENT'
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngCodeMasterAutocompleteField
          required
          name="cargoType"
          label={t.cargoType}
          disabled={disabled}
          codeType='UAE_MPCI_CARGO_TYPE'
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngCodeMasterAutocompleteField
          name="sealingPartyCode"
          label={t.sealingPartyCode}
          disabled={disabled}
          codeType='UAE_MPCI_SEALING_PARTY'
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          name="sealingPartyName"
          label={t.sealingPartyName}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 35 }}
          onChange={(e) => setValue("sealingPartyName", e.target.value.toUpperCase(), { shouldValidate: true })}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngCodeMasterAutocompleteField
          name="sealType"
          label={t.sealType}
          disabled={disabled}
          codeType='UAE_MPCI_SEAL_TYPE'
          size='small'
        />
      </CngGridItem>
    </Grid>
  )
}

const FormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields
})

export default FormProperties
